class ServiceModal extends HTMLElement {
  constructor() {
    super();
    this.focusableElements = null;
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.previousActiveElement = null;
  }

  connectedCallback() {
    this.closeButtons = this.querySelectorAll('[data-service-modal-close]');
    this.form = this.querySelector('form');

    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    document.addEventListener('keydown', this.handleKeydown.bind(this));

    // Set up trigger buttons
    document.querySelectorAll('[data-service-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', this.open.bind(this));
    });
  }

  open() {
    this.previousActiveElement = document.activeElement;
    this.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Set up focus trapping
    this.focusableElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    this.firstFocusable = this.focusableElements[0];
    this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    // Focus the first focusable element
    setTimeout(() => {
      if (this.firstFocusable) {
        this.firstFocusable.focus();
      }
    }, 100);
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Return focus to previous element
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }

  handleKeydown(event) {
    if (this.getAttribute('aria-hidden') === 'true') return;

    // Close on ESC
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    // Focus trapping
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === this.firstFocusable) {
          event.preventDefault();
          this.lastFocusable.focus();
        }
      } else {
        if (document.activeElement === this.lastFocusable) {
          event.preventDefault();
          this.firstFocusable.focus();
        }
      }
    }
  }

  handleSubmit(event) {
    const submitButton = this.form.querySelector('.service-modal__submit');
    if (submitButton) {
      submitButton.classList.add('loading');
      submitButton.disabled = true;
    }
  }
}

customElements.define('service-modal', ServiceModal);
